var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTabQrcode(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 15.448,
    height: 16,
    viewBox: "0 0 15.448 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_27172",
    "data-name": "Group 27172",
    transform: "translate(-5412.925)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icon_ionic-ios-qr-scanner",
    "data-name": "Icon ionic-ios-qr-scanner",
    transform: "translate(5412.925)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_37770",
    "data-name": "Path 37770",
    d: "M8.263,4.5H5.982A2.608,2.608,0,0,0,3.375,7.107V9.388a.543.543,0,0,0,1.086,0V7.068A1.579,1.579,0,0,1,5.943,5.586h2.32a.543.543,0,0,0,0-1.086Z",
    transform: "translate(-3.375 -4.5)",
    fill: "#1c1c1c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_37771",
    "data-name": "Path 37771",
    d: "M25.644,4.5h-2.32a.543.543,0,0,0,0,1.086h2.32a1.579,1.579,0,0,1,1.482,1.482v2.32a.543.543,0,1,0,1.086,0V7.068A2.571,2.571,0,0,0,25.644,4.5Z",
    transform: "translate(-12.764 -4.5)",
    fill: "#1c1c1c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_37772",
    "data-name": "Path 37772",
    d: "M8.263,26H5.943a1.579,1.579,0,0,1-1.482-1.482V22.2a.543.543,0,1,0-1.086,0v2.32a2.571,2.571,0,0,0,2.568,2.568h2.32a.543.543,0,1,0,0-1.086Z",
    transform: "translate(-3.375 -11.087)",
    fill: "#1c1c1c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_37773",
    "data-name": "Path 37773",
    d: "M27.669,21.656a.545.545,0,0,0-.543.543v2.32A1.579,1.579,0,0,1,25.644,26h-2.32a.543.543,0,0,0,0,1.086h2.281a2.61,2.61,0,0,0,2.607-2.607V22.2A.545.545,0,0,0,27.669,21.656Z",
    transform: "translate(-12.764 -11.087)",
    fill: "#1c1c1c"
  })), /*#__PURE__*/React.createElement("line", {
    id: "Line_2",
    "data-name": "Line 2",
    x2: 12.69,
    transform: "translate(5414.346 8)",
    fill: "none",
    stroke: "#1c1c1c",
    strokeLinecap: "round",
    strokeWidth: 1
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTabQrcode);
export default __webpack_public_path__ + "static/media/tab-qrcode.128b355df00dfd8dcb45a7bdce83229d.svg";
export { ForwardRef as ReactComponent };